import {
  BeamQualityContainerDto,
  BeamShapingContainerDto,
  DiscreteNumericListDto,
  DiscreteNumericValueDto,
  EntityOrigin,
  FaultyNumericValueDto,
  instanceOfDiscreteNumericListDto,
  instanceOfDiscreteNumericValueDto,
  instanceOfFaultyNumericValueDto,
  instanceOfNumericListDto,
  instanceOfNumericValueDto,
  ISingleSystemSetupParameter,
  NumericListDto,
  NumericValueDto,
} from '@/api/generator';

export type TaskItemSetupParameters = {
  singleSetupParameters?: ISingleSystemSetupParameter[];
  beamQualityContainer?: BeamQualityContainerDto;
  beamShapingContainer?: BeamShapingContainerDto;
};

export type SetupParameter = {
  name: string;
  iuid: string;
  unitAbbreviation?: string | null;
  origin?: EntityOrigin | null;
};

export interface SetupParameterOverviewFilterObject {
  search?: string;
}

export type SingleSetupParameterWithGeometry =
  | DiscreteNumericListDto
  | DiscreteNumericValueDto
  | FaultyNumericValueDto
  | NumericListDto
  | NumericValueDto;

export function instanceOfSingleSetupParameterWithGeometry(
  value: unknown,
): value is SingleSetupParameterWithGeometry {
  return (
    instanceOfDiscreteNumericListDto(value) ||
    instanceOfDiscreteNumericValueDto(value) ||
    instanceOfFaultyNumericValueDto(value) ||
    instanceOfNumericListDto(value) ||
    instanceOfNumericValueDto(value)
  );
}
